export const getSafeAreaInsets = () => {
  if (typeof window === 'undefined')
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    };

  // Create a temporary element to attach the safe area inset values
  const tempElement = document.createElement('div');
  document.body.appendChild(tempElement);

  // Apply styles to get the safe area insets
  tempElement.style.cssText = `
      position: absolute;
      top: env(safe-area-inset-top, 0px);
      right: env(safe-area-inset-right, 0px);
      bottom: env(safe-area-inset-bottom, 0px);
      left: env(safe-area-inset-left, 0px);
      visibility: hidden;
  `;

  // Get the computed styles of the element
  const computedStyle = getComputedStyle(tempElement);

  // Extract the safe area insets
  const safeAreaInsets = {
    top: parseInt(computedStyle.top, 10) || 0,
    right: parseInt(computedStyle.right, 10) || 0,
    bottom: parseInt(computedStyle.bottom, 10) || 0,
    left: parseInt(computedStyle.left, 10) || 0,
  };

  // Remove the temporary element
  document.body.removeChild(tempElement);

  return safeAreaInsets;
};
